export const ENV = {
  env: process.env.REACT_APP_ENV as string,
  baseApi: process.env.REACT_APP_BASE_API as string,
  clientId: process.env.REACT_APP_CLIENT_ID as string,
  redirectUrl: process.env.REACT_APP_REDIRECT_URL as string,
};
